import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { FileDownload, GridOn } from '@mui/icons-material';
import { useTranslate } from 'react-admin';

export interface ReportExportButtonsProps {
  onExportCSV?: () => void;
  onExportExcel?: () => void;
  onExportPDF?: () => void;
  exporting?: boolean;
  disabled?: boolean;
}

export const ReportExportButtons: React.FC<ReportExportButtonsProps> = ({
  onExportCSV,
  onExportExcel,
  onExportPDF,
  exporting = false,
  disabled = false,
}) => {
  const translate = useTranslate();

  return (
    <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, flexWrap: 'wrap' }}>
      {/* CSV Export */}
      {onExportCSV && (
        <Button
          variant="outlined"
          startIcon={exporting ? <CircularProgress size={16} /> : <FileDownload />}
          onClick={onExportCSV}
          disabled={disabled || exporting}
          size="small"
          sx={{
            borderColor: '#009A75',
            color: '#009A75',
            '&:hover': {
              borderColor: '#008060',
              backgroundColor: '#009A7510',
            },
          }}
        >
          {translate('reports.export.csv', { fallback: 'Export CSV' })}
        </Button>
      )}

      {/* Excel Export */}
      {onExportExcel && (
        <Button
          variant="outlined"
          startIcon={exporting ? <CircularProgress size={16} /> : <GridOn />}
          onClick={onExportExcel}
          disabled={disabled || exporting}
          size="small"
          sx={{
            borderColor: '#2196F3',
            color: '#2196F3',
            '&:hover': {
              borderColor: '#1976D2',
              backgroundColor: '#2196F310',
            },
          }}
        >
          {translate('reports.export.excel', { fallback: 'Export Excel' })}
        </Button>
      )}

      {/* PDF Export */}
      {onExportPDF && (
        <Button
          variant="outlined"
          startIcon={exporting ? <CircularProgress size={16} /> : <FileDownload />}
          onClick={onExportPDF}
          disabled={disabled || exporting}
          size="small"
          sx={{
            borderColor: '#FF6B6B',
            color: '#FF6B6B',
            '&:hover': {
              borderColor: '#FF5252',
              backgroundColor: '#FF6B6B10',
            },
          }}
        >
          {translate('reports.export.pdf', { fallback: 'Export PDF' })}
        </Button>
      )}
    </Box>
  );
};
